/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import shortid from 'shortid';

// assets
import iconCloseX from '../../../assets/img/icon-close-x.svg';

import './modal.css';

const Modal = ({
  id,
  children,
  isOpen,
  closeModal,
  unableToClose,
  closeEscKey,
  closeClickOutside,
  className = '',
}) => {
  useEffect(() => {
    if (!unableToClose && closeEscKey) {
      /* istanbul ignore next */
      const closeKeyDown = (e) => {
        if (e.keyCode === 27) {
          closeModal();
        }
      };
      /* istanbul ignore next */
      window.addEventListener('keydown', closeKeyDown);
      /* istanbul ignore next */
      return () => window.removeEventListener('keydown', closeKeyDown);
    }
  }, []);

  const handleClickKeypressInModalContent = (e) => e.stopPropagation();
  const handleClickCloseModal = () => {
    if (!unableToClose && closeClickOutside) closeModal();
  };

  return (
    <section
      role="button"
      onClick={handleClickCloseModal}
      tabIndex="0"
      className={`${className} modal-container ${isOpen ? 'modal-container--is-open' : ''}`}
    >
      <section
        onClick={handleClickKeypressInModalContent}
        role="button"
        tabIndex="0"
        className="modal-content"
        id={id || shortid.generate()}
      >
        {!unableToClose && (
          <button type="button" className="modal-close" onClick={closeModal}>
            <img src={iconCloseX} alt="" width="14" />
          </button>
        )}
        {children}
      </section>
    </section>
  );
};

export default Modal;
